import {t} from "../../i18n";
import {showValidationErrors} from "../../utils/formHelpers";

export default function authLoginAlt({ $, api, state, data, routes, emit, sharedState, onNext, onComplete, onSaveState }) {
    function render({ decoded }) {
        const isCreate = sharedState.v.b(1) === 0;
        const hasFacebook = sharedState.v.b(2) === 1;
        const hasGoogle = sharedState.v.b(3) === 1;

        let social = '';
        social += !hasFacebook ? `` : `
        <button class="auth-option-button step-login-facebook">
            <svg class="icon"><use xlink:href="#icon-facebook"></use></svg>
            <span>${t('continue_with_facebook')}</span>
        </button>
        `;
        social += !hasGoogle ? `` : `
        <button class="auth-option-button step-login-google">
            <svg class="icon"><use xlink:href="#icon-google"></use></svg>
            <span>${t('continue_with_google')}</span>
        </button>
        `;
        if(social.length > 0) {
            social += `<p class="or-line">${t('or')}</p>`
        }

        const $el = $(isCreate ? `
    <div class="step-login-alt-row active" data-auth-step="booking-login-alt">
        <div class="auth-prev-button auth-back-btn is-creation" data-step="booking-init">
            <svg class="icon"><use xlink:href="#icon-back"></use></svg>
        </div>
        <h2 class="is-creation">${t('loginAlt.noPassTitle')}</h2>
        ${social}
        <button class="auth-option-button login-email-button is-creation">
            ${t('loginAlt.noPassLinkText')}
            <small>${t('loginAlt.noPassLinkDetails')}</small>
        </button>
    </div>
        ` : `
    <div class="step-login-alt-row active" data-auth-step="booking-login-alt">
        <div class="auth-prev-button auth-back-btn is-not-creation" data-step="booking-login">
            <svg class="icon"><use xlink:href="#icon-back"></use></svg>
        </div>
        <h2 class="is-not-creation">${t('loginAlt.lostPassTitle')}</h2>
        ${social}
        <button class="auth-option-button login-email-button is-not-creation">
            ${t('loginAlt.lostPassLinkText')}
            <small>${t('loginAlt.lostPassLinkDetails')}</small>
        </button>
    </div>
        `);

        if(isCreate) {
            $el.addClass('creation');
        } else {
            $el.removeClass('creation')
        }

        $el.on('click', '.step-login-facebook', () => emit('social_login_clicked', 'facebook'));
        $el.on('click', '.step-login-google', () => emit('social_login_clicked', 'google'));
        $el.on('click', '.login-email-button', () => {
            const email = sharedState.email;
            api.post(routes.resetPassword, {
                data: {
                    email: email,
                },
                success: (data) => {
                    onNext('booking-check-email', { email });
                },
                error: (err) => {
                    console.warn('Failed:', err);
                    showValidationErrors($el, err.data.errors || {});
                }
            })
        });

        return $el;
    }

    return { render };
}